module.exports = __webpack_public_path__ + "static/media/sequencing-dog-yellow.c94bf0ec.svg";